import { useMemo } from 'react'

import { useInvoiceActionFlags } from '@features/invoices/hooks/useInvoiceActionFlags'

import { useInvoice } from '../../../contexts/invoiceContext'
import { isInvoiceAlreadySent } from '../../../utils/isInvoiceAlreadySent'
import { InvoiceActionType } from '../enums/InvoiceActionType'

export const useInvoiceViewActions = () => {
  const { invoice, documentType } = useInvoice()
  const {
    actionButtonDisplayLimit,
    canCreateCreditNote,
    canRegisterPayment,
    canSendPaymentReminder,
    isCancellable,
    isDuplicable,
    isMarkableAsSent,
    isUnmarkableAsSent,
    shouldDisplayOpenInZervantAction,
  } = useInvoiceActionFlags({ invoice, documentType })

  const invoiceViewActions: InvoiceActionType[] = useMemo(
    () => [
      ...(canRegisterPayment ? [InvoiceActionType.RegisterPayment] : []),
      InvoiceActionType.Share,
      ...(shouldDisplayOpenInZervantAction ? [InvoiceActionType.OpenInZervant] : []),
      ...(canSendPaymentReminder ? [InvoiceActionType.SendPaymentReminder] : []),
      ...(isDuplicable ? [InvoiceActionType.Duplicate] : []),
      ...(isCancellable && !isInvoiceAlreadySent(invoice) ? [InvoiceActionType.Cancel] : []),
      ...(canCreateCreditNote ? [InvoiceActionType.CreateCreditNote] : []),
      ...(isMarkableAsSent ? [InvoiceActionType.MarkAsSent] : []),
      ...(isUnmarkableAsSent ? [InvoiceActionType.UnmarkAsSent] : []),
    ],
    [
      canCreateCreditNote,
      canSendPaymentReminder,
      canRegisterPayment,
      invoice,
      isDuplicable,
      isCancellable,
      isMarkableAsSent,
      isUnmarkableAsSent,
      shouldDisplayOpenInZervantAction,
    ],
  )

  const invoiceActionsDisplayedAsButtons = useMemo(
    () => invoiceViewActions.slice(0, actionButtonDisplayLimit),
    [actionButtonDisplayLimit, invoiceViewActions],
  )

  const invoiceActionsDisplayedAsMenuItems = useMemo(
    () => invoiceViewActions.slice(actionButtonDisplayLimit),
    [actionButtonDisplayLimit, invoiceViewActions],
  )

  return { invoiceActionsDisplayedAsButtons, invoiceActionsDisplayedAsMenuItems }
}
